import {
	Viewer,
	User,
	ClassUserWithProfile,
} from '@/apollo/gql/generated/graphql';

export const fullName = (viewer: Viewer) =>
	`${viewer.firstName} ${viewer.lastName}`;

export const getViewerFromConnection = (connection: OT.Connection): Viewer => {
	const user = JSON.parse(connection.data);
	return user;
};

export const getUserIdFromConnection = (connection: OT.Connection): string => {
	const { id: userId }: { id: string } = JSON.parse(connection.data);
	return userId;
};

export const getUserIdFromStream = (stream: OT.Stream): string => {
	const id = getUserIdFromConnection(stream.connection);

	return id;
};

export const getUserDataFromStream = (stream: OT.Stream): User => {
	const data = JSON.parse(stream?.connection.data);
	return data;
};

export const normalizeUser = (user: ClassUserWithProfile) => ({
	...user,
	arrivalOrder: Number(user?.id),
	id: user?.userId,
	firstName: user?.User?.firstName,
	lastName: user?.User?.lastName,
	username: user.User?.username,
	profilePictureUrl: user?.User?.profilePictureUrl,
	connections: user?.Connections,
});

export const userInitials = (user: { firstName: string; lastName: string }) =>
	`${user.firstName[0]}${user.lastName[0]}`;
